import { render } from "./VestingAllocationAndClaimProcess.vue?vue&type=template&id=5fc019d8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__